<template>
  <div class="fit-content">
    <div style="display: flex">
      <div v-for="(item, index) in upElementBlocks" :key="index" class="section form-column" :style="{width: item.width + 'px'}">
        <span class="title">{{ item.title }}</span>
        <template v-for="elementName in item.elementNames">
          <slot :name="elementName" />
          <template v-if="elementName === 'jobNo'">
            <slot name="saleProductCode" />
            <slot name="fullOrInside" />
          </template>
        </template>
      </div>
    </div>
    <template v-for="(item, index) in downElementBlocks">
      <div v-if="item.name === 'cargoInfo' || item.name === 'CargoInformation'" :key="index" style="flex-direction: column">
        <div class="section">
          <span class="title">{{ item.title }}</span>
          <div style="width: 1100px;display: flex;flex-wrap: wrap">
            <slot name="goodsInfo" />
            <template v-for="(elementName, index) in item.elementNames">
              <template v-if="lineBreak.hasOwnProperty(elementName) && lineBreak[elementName]">
                <div :key="index" style="width: 100%;" />
              </template>
              <slot :name="elementName" />
            </template>
          </div>
        </div>
      </div>
      <div v-else-if="item.name === 'customerDeliveryInfo' || item.name === 'CustomerShippingInformation'" :key="index" class="section" style="width:100%">
        <span class="title">{{ item.title }}</span>
        <slot name="codeSearching" />
        <div class="form-row" style="display:flex;flex-direction:row;margin-top:8px">
          <slot v-for="elementName in item.elementNames" :name="elementName" />
        </div>
      </div>
    </template>
  </div>
</template>

<script>
export default {
  name: 'TabGeneralUICustomLayout',
  props: {
    elementBlocks: { type: Array, required: true },
    elementDict: { type: Object, required: true }
  },
  data() {
    return {
      lineBreak: {
        cargoChineseName: false,
        cargoEnglishName: false,
        mark: false
      }
    }
  },
  computed: {
    upElementBlocks() {
      return this.elementBlocks.filter(p => p.position === 1 && !p.hide)
    },
    downElementBlocks() {
      return this.elementBlocks.filter(p => p.position === 2 && !p.hide)
    }
  },
  watch: {
    elementBlocks() {
      this.init()
    },
    elementDict() {
      this.init()
    }
  },
  created() {
    this.init()
  },
  methods: {
    init() {
      const lineBreak = this.lineBreak
      lineBreak.cargoChineseName = false
      lineBreak.cargoEnglishName = false
      lineBreak.mark = false
      const cargoInfo = this.elementBlocks.find(p => p.position === 2 && !p.hide && (p.name === 'cargoInfo' || p.name === 'CargoInformation'))
      if (cargoInfo) {
        let isNewLine = true
        for (let i = 0; i < cargoInfo.elementNames.length; ++i) {
          const elementName = cargoInfo.elementNames[i]
          if (this.elementDict[elementName]) {
            if (lineBreak.hasOwnProperty(elementName)) {
              lineBreak[elementName] = isNewLine
              isNewLine = false
            } else {
              isNewLine = true
            }
          }
        }
      }
    }
  }
}
</script>
